import React from 'react';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { styled } from '@mui/material/styles';
import { Controller, useFormContext } from 'react-hook-form';

export interface IRhfSimpleDatePickerProps {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

const StyledDatePicker = styled(DatePicker)({
  width: '100%',
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    backgroundColor: '#F5F6FA',
    borderColor: '#BFBFBF',
  },
  '& .MuiInputBase-input': {
    paddingTop: '12px',
    paddingBottom: '12px',
  },
});

export const RhfSimpleDatePicker: React.FC<IRhfSimpleDatePickerProps> = ({ name, label, placeholder = 'DD-MMM-YYYY', disabled = false }) => {
  const { control } = useFormContext();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <StyledDatePicker
            {...field}
            label={label}
            disabled={disabled}
            format='dd-MMM-yyyy'
            slotProps={{
              textField: {
                placeholder,
                fullWidth: true,
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};
